import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators'
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'sheetjs-style';
import * as colabInter from './template-admin.interfaces';
import * as catalogosHoja from './template-admin.catalogos';
import * as backInter from 'app/auth/auth-data.model';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { TemplateService } from 'app/main/wizard-cgo/services/template.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_secciones } from 'app/idiomas/i18n/Izzi/izzisecciones/izzisecciones.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_modales_izzi } from 'app/idiomas/i18n/Izzi/izzimodales/izzimodales.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { lang_template } from 'app/idiomas/i18n/template/template.lang';
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { EnvioService } from 'app/main/wizard-cgo/services/envio.service';
// import { SurveyCheckComponent } from "../programacion/vista-gen/survey-check/survey-check.component";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import * as catalogos from './catalogostem';
type AOA = any[][];
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { AuthService } from 'app/auth/auth.service';
import { SurveyProductService } from "app/main/wizard-cgo/survey-product/survey-product.service";

import { DATOS_API } from 'app/auth/auth.datos';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
const moment = require('moment');
const momentTz = require('moment-timezone');

@Component({
  selector: 'app-template-admin',
  templateUrl: './template-admin.component.html',
  styleUrls: ['./template-admin.component.scss'],
  animations : fuseAnimations
})
export class TemplateAdminComponent implements OnInit, OnDestroy {

  _unsubscribeAll: Subject<any>;

  urlAssets = DATOS_API.urlAssets;

  cargando = true;
  cargandoBD = false;
  guardandoBD = false;
  stored = false;
  colabsEnBD = 0;
  fechaCarga:string;

  idiomaActual:string;
  instituto: string;
  nombreEmpresa: string;

  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';

  charIdiomas = this.charChinos + this.charTurcos;

  regexAlfabetico = new RegExp("^[" + this.charIdiomas + "a-zA-Z  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexAlfanumerico = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexNumerico = new RegExp("^[0-9]+$");
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  data: AOA = [];
  files: any = [];

  totRows = 0;

  filaInicial: number;

  arregloColaboradores: colabInter.Colaborador[] = [];
  errores:colabInter.errorEncontrado[] = [];
  erroresTotales = 0;

  nombresColumnas: string[] = [];
  clavesColumnas: string[] = [];
  nombresColumnasBD = {} as colabInter.Colaborador;

  columnasObligatorias: any[] = colabInter.COLUMNAS_OBLIGATORIAS;

  // Datos certificar vigente
  productoCertificar: any;

  //id idioma nativo
  idLangNativo: string;
  // tipos demograficos guardados
  // tiposDemograficos: backInter.allDemograficos;
  tiposDemograficos: any[] = [];

  //opciones demograficas
  opcionesDemograficas: any[] = [];

  claveAge = 'Age';
  claveGender = 'Gender';
  claveTOW = 'Type of work';
  claveWC = 'Work condition';
  claveAntiq = 'Antiquity';
  actualizadoUsuario=false;

  //claves random surveykeyhk
  skhk: any[] = [];

  //boolean ceo encontrado
  ceoEncontrado = false;

  //boolean paso completo
  pasoCompleto = false;

  //libreria moment
  moment = require('moment');

  //version nueva excel
  versionNueva: boolean;

  datosSurveyCheck:any;
  token:any;

  userData:any;
  validationUser:boolean=false;
  validationSurvey:boolean=false;
  desbloqueoEstatus:boolean=false;


  //zonas horarias
  zonasUTC = zonasUTC;
  idiomaUtc: string;
  instUtc: number;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;


  idiomaNative = 'es';
  idiomas:any;
  jsonCuestionario: any;
  preguntasCatalogoMaestro:any;
  catalogoRespForall: any;
  pregStatement1: any;
  pregStatement2: any;
  catalogoDemograficos:any;
  maxQuestions4All:number;
  tiposSeccionesExcel:any[]=[
    { clave: 1, nombre: 'Nps', claveSeccion: 'NPS', visible: true },
    { clave: 2, nombre: 'Reactivos', claveSeccion: 'Reactivos', visible: true },
    { clave: 3, nombre: 'Control', claveSeccion: 'Control', visible: true },
    { clave: 4, nombre: 'Demograficos', claveSeccion: 'Demograficos', visible: true },
    { clave: 5, nombre: 'Abiertas', claveSeccion: 'Abiertas', visible: true },
    { clave: 6, nombre: 'Forall', claveSeccion: 'Forall', visible: true },
    { clave: 7, nombre: 'Adicionales', claveSeccion: 'Adicionales', visible: true },
  ];

  tipoRespuestaExcel:any[]=[
    { clave: '1', nombre: 'radio' },
    { clave: '2_1', nombre:'abiertaTexto' },
    { clave: '2_2', nombre:'abiertaNumerico' },
    { clave: '3', nombre: 'reactivo' },
    { clave: '4', nombre: 'demografico' },
    { clave: '5', nombre: '4all' },
    { clave: '6', nombre: 'checkbox' },
  ];

  columnasExcel = catalogosHoja.columnasExcel;

  catalogoIdiomasSurvey: any;
  catalogoRespReactivos: any;
  totalPreguntaNueva:number=0;
  totalPreguntaModificadas:number=0;
  totalPreguntas:number=0;
  /////Variables que se muestran cuando ya se cargo plantilla
  totalPreguntaNuevasCargadas:number=0;
  totalPreguntaModificadasCargadas:number=0;
  totalPreguntasCargadas:number=0;
  sinModificacionTemplate=false;

  cargaTemplate: boolean;
  cargandoTemplatePreguntas=false;
  guardandoTemplatePreguntas=false;
  varibleModal=0;
  forAllExcedidas = false;
  nameUserAdmin:any="";
  nivelNotificacion:number;

  statusPreguntasCargadas: any[] = [];
  preguntasCatalogoCargadas: boolean;

constructor(private encuestaService: EncuestaService,
  private colaboradoresService: ColaboradoresService,
  private wizardService: WizardService,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,
  private dialog: MatDialog,
  private _snackBar: MatSnackBar,
  private programacionService:ProgramacionService,
  private envioService: EnvioService,
  private templateService: TemplateService,
  private idiomasService: IdiomasService,
  public authService: AuthService,
  private surveyProductService: SurveyProductService
) {
  this._unsubscribeAll = new Subject();
  if(localStorage.getItem('tipoIzzi')){
    lang_secciones.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }
  else{
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }
  lang_shedule.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_template.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_cerv3.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
  this.translateSrv.onLangChange.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => { this.traduceTextosTS(); });
  //obtiene id instituto
  this.obtieneInstituto();

  if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
      this.nameUserAdmin=this.userData.user;
    }
    else{
      this.validationUser=false;
      this.nameUserAdmin="";
    }
  }
}

ngOnInit() {
  console.log("se recuperará información del surveyproduct");
  this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
  this.recibeDatosSP();
}

recibeDatosSP(){
  // this.surveyProductService.recibidosSurvProd.pipe(first()).subscribe((datos:any) => {
  console.log("se inicializó la espera de la respuesta del surveyproduct");
  this.surveyProductService.recibidosSurvProd.pipe(takeUntil(this._unsubscribeAll)).subscribe((datos:any) => {
    console.log("---------------------------DATOS RECIBIDOS :V ----------------------------");
    console.log(datos);
    if(datos.recuperaInformacion == true){
      this.obtieneCertificarActual(JSON.parse(JSON.stringify(datos)));
      this.getPreguntasCatalogo(datos.catalogo);
    }
  });
}

obtieneCertificarActual(datosProducto: any){
  /// obtiene el producto certificar vigente
  this.productoCertificar = datosProducto.productoCertificar;
  this.getSeccionesCuestionario(datosProducto);
  this.obtieneIdiomasGuardados(datosProducto);
  //obtiene el status del paso adicionales del certificar vigente
  this.templateService.getStatusTemplate(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
    if(data.estatus === 3)
    this.pasoCompleto = true;
  });

  this.idiomasService.getNivelNotificacionCatServ(this.instUtc).subscribe( (data: any) => {
    console.log('entro get catalogo niveles notificaciones',data);
    this.nivelNotificacion=data.catlNotificationBroker[0].secciones.template.levelNotification;
    // console.log('this.nivelNotificacion::',this.nivelNotificacion);
  });

  //obtiene la lista de secciones del producto y oculta las que no estén disponibles en el mismo
  let datosGetSecc = { productoId: this.productoCertificar.idCertificar };
  this.wizardService.getSeccionesCertificar(datosGetSecc).subscribe((data:any) => {
    console.log("getSeccionesCertificar:",data);
    if(data.success){
      data.secciones.forEach( (seccion) => {
        let indiceSeccion = this.tiposSeccionesExcel.findIndex(item => item.claveSeccion == seccion.nombre);
        this.tiposSeccionesExcel[indiceSeccion].visible = seccion.estatus;
      });
    }
  });

  this.getStatusModal();
  this.getActualizaTemplate();

  this.wizardService.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
    this.nombreEmpresa = data.data.nombreEmpresa;
  });
}

obtieneIdiomasGuardados(datosProducto: any){
  this.idiomas = datosProducto.idiomas;
  let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
  this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
  this.getCatRespuestasReactivos(datosProducto.catalogoRespReactivos);
  this.getCatDatosForAll(datosProducto.catalogoRespForall);
  this.getCatDemograficos(datosProducto.catalogoDemograficos);
  this.getCatIdiomasSurvey(datosProducto.catalogoIdiomasSurvey);
}

getPreguntasCatalogo(datos:any){
  this.preguntasCatalogoMaestro = datos;
}

getCatRespuestasReactivos(datos:any){
  this.catalogoRespReactivos = datos;
}

getCatDatosForAll(datos:any){
  this.catalogoRespForall = datos;
  this.pregStatement1 = datos[0];
  this.pregStatement2 = datos[1];
  // console.log(this.pregStatement1);
  // console.log(this.pregStatement2);
}

getCatDemograficos(datos:any){
  this.catalogoDemograficos = datos;
}

getCatIdiomasSurvey(datos:any){
  this.catalogoIdiomasSurvey = datos;
}

getSeccionesCuestionario(datosProducto: any){
  this.jsonCuestionario = datosProducto.surveyProduct;
  setTimeout(() => {
    this.cargando = false;
    let esperaStatusTemp = setInterval(() => {
      if(this.cargaTemplate != undefined){  //si el estatus de carga ya se recupero
        if(this.sinModificacionTemplate == false){ //si el estatus de modificacion es false (no se ha modificado)
          this.obtienePreguntasCatalogoEnSP();
        }
        clearInterval(esperaStatusTemp);
      }
    },0);
  }, 1000);
}


getActualizaTemplate(){
  let dato:any= this.productoCertificar.surveyProductId._id;
  this.templateService.getActualizaTemplate(dato).subscribe((respuesta:any) => {
    console.log("get actualiza ok",respuesta);
    if (respuesta.records.length>0) {
      this.totalPreguntaNuevasCargadas=respuesta.records[0].newQuestions;
      this.totalPreguntaModificadasCargadas=respuesta.records[0].modifiedQuestions;
      this.totalPreguntasCargadas=respuesta.records[0].totalQuestions;
      this.sinModificacionTemplate=true;
      this.cargaTemplate=true;
    }else{
      this.cargaTemplate=false;
    }
  });
}

buscaUltimaIdUnique99999(){
  let arregloIds: any[] = [99999];
  this.jsonCuestionario.sections.forEach((seccion:any) => {
    seccion.questions.forEach(pregunta => {
      if(pregunta.idUnique > 99999){
        arregloIds.push(pregunta.idUnique);
      }
    });
  });
  arregloIds.sort((a,b)=>a-b);
  console.log("ultimoIdUnique:",arregloIds[arregloIds.length - 1]);
  return arregloIds[arregloIds.length - 1] + 1;
}

// NO ME ACUERDO PARA QUE SE USA ESTA FUNCION, ASI QUE LA VOY A DEJAR COMENTADA POR SI ALGUN DIA SIRVE PA ALGO :V
// reemplazarPreguntasPorCatalogo(){
//   let arregloPreguntas: any[] = [];
//   // this.jsonCuestionario.sections.forEach(section => {
//   this.tiposSeccionesExcel.forEach(section => {
//     let seccion = {
//       clave: section.clave,
//       preguntas: []
//     };
//     this.preguntasCatalogoMaestro.forEach(pregunta => {
//       if(pregunta.typeSection == section.clave){
//         seccion.preguntas.push(pregunta);
//       }
//     });
//     arregloPreguntas.push(seccion);
//   });
//   console.log("arregloPreguntas:",arregloPreguntas);
//   this.jsonCuestionario.sections.forEach(seccion => {
//     let indiceTipoSeccion = arregloPreguntas.findIndex(item => item.clave == seccion.typeSection);
//     if(indiceTipoSeccion != -1){
//       seccion.questions = [];
//       arregloPreguntas[indiceTipoSeccion].preguntas.forEach(pregunta => {
//         seccion.questions.push(this.mapJsonPregCatJsonPregunta(pregunta));
//       });
//     }
//   });
//   console.log("nuevoJsoncuestionario:",this.jsonCuestionario);
// }

mapJsonPregCatJsonPregunta(preguntaCat: any, versionSel?:number){ //esta funcion transforma el json de una pregunta de catalogo a json de pregunta del template
  let answersPregTemp: any[] = [];
  preguntaCat.answers.forEach(answCat => {
    let ansPregTemp = {
      answerLanguage: answCat.textVersions[0].answerLanguage,
      idUnique: answCat.idUnique,
      logics: [],
      value: answCat.value,
      versionId: 1,
      vivo: 1,
    };
    answersPregTemp.push(ansPregTemp);
  });
  let indiceVersion = 0;
  let versionElegida = 1;
  if(versionSel){
    indiceVersion = preguntaCat.textVersions.findIndex(item => item.versionId == versionSel);
    versionElegida = versionSel;
  }
  let preguntaTemplate = {
    answerType: preguntaCat.answerType,
    answers: answersPregTemp,
    color: 1,
    columns: this.jsonCuestionario.columns,
    delete: true,
    demographicId: preguntaCat.demographicId,
    edit: true,
    idUnique: preguntaCat.idUnique,
    jsonCustom: preguntaCat.jsonCustom,
    order: 1,
    preload: false,
    questionLanguage: preguntaCat.textVersions[indiceVersion].questionLanguage,
    required: 1,
    typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
    versionId: versionElegida,
    vivo: 1,
  };
  return preguntaTemplate;
}

async getDatosPreguntaCatalogo(idUnique:number){
  return this.surveyProductService.getPreguntaCatMaster(idUnique).toPromise();
}

obtienePreguntasCatalogoEnSP(){
  this.statusPreguntasCargadas = [];
  this.jsonCuestionario.sections.forEach(section => {
  // for(let section of this.jsonCuestionario.sections){
    if (section.typeSection != 6) {
      for(let pregunta of section.questions){
        this.statusPreguntasCargadas.push({
          idUnique: pregunta.idUnique,
          status: pregunta.idUnique < 100000 ? false : true
        });
        if(pregunta.idUnique < 100000){
          // const {question: datosPreguntaCatalogo} = await this.surveyProductService.getPreguntaCatMaster(pregunta.idUnique).toPromise();
          this.surveyProductService.getPreguntaCatMaster(pregunta.idUnique).subscribe((respuesta:any) => {
            let indicePreguntaCat = this.preguntasCatalogoMaestro.findIndex(item => item.idUnique == respuesta.question.idUnique);
            this.preguntasCatalogoMaestro[indicePreguntaCat] = respuesta.question;

            const indicePregStatus = this.statusPreguntasCargadas.findIndex(item => item.idUnique == respuesta.question.idUnique);
            this.statusPreguntasCargadas[indicePregStatus].status = true;
            if(this.statusPreguntasCargadas.every(this.preguntaCatOk)){
              this.preguntasCatalogoCargadas = true;
            }
          });
        }
      }
    }
  // }
  });
}
preguntaCatOk(pregunta){ return pregunta.status === true };

async descargaExcel(){
  console.log(" preguntasCatalogoMaestro",this.preguntasCatalogoMaestro);
  console.log(" jsoncuestionario",this.jsonCuestionario);
  Swal.fire({
    title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.MENSAJES.EXCEL'),
    didOpen: () => {
      Swal.showLoading()
    }
  });
  var wb = XLSX.utils.book_new(); //
  wb.Props = {
    Title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.TITULO'),
    Subject: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.ASUNTO'),
    Author: this.translateSrv.instant('CERTIFICAR.COLABORADORES.EXCELINFO.AUTOR'),
    CreatedDate: new Date()
  };

  wb.SheetNames.push(this.translateSrv.instant('TEMPLATE.HOJAS_EXCEL.Detalles'));
  wb.Sheets[this.translateSrv.instant('TEMPLATE.HOJAS_EXCEL.Detalles')] = this.creaHojaDetalles();

  // Solo se agrega la hoja de catalogo de demograficos si la seccion esta activa en el producto
  let statusSeccionDemog = this.tiposSeccionesExcel.find(item => item.clave == 4);
  if(statusSeccionDemog.visible){
    wb.SheetNames.push(this.translateSrv.instant('TEMPLATE.HOJAS_EXCEL.CatDemograficos'));
    wb.Sheets[this.translateSrv.instant('TEMPLATE.HOJAS_EXCEL.CatDemograficos')] = this.creaHojaCatDemograficos();
  }

  // this.tiposSeccionesExcel.forEach(seccion => {
  for(let seccion of this.tiposSeccionesExcel){
    if(seccion.clave!=6){
      let contradorColumnas=0;
      if(seccion.visible){    //si la sección está disponible en el producto se le crea la hoja al excel
        // let nombreHoja= seccion.clave+"-"+seccion.nombre;
        let nombreHoja= seccion.clave+"-"+this.translateSrv.instant('TEMPLATE.HOJAS_EXCEL.'+seccion.nombre);
        // let nombreHojaOriginal= seccion.clave+"_original"; //nombre de hoja clon con datos originales, para validacion al cargar
        wb.SheetNames.push(nombreHoja);
        // wb.SheetNames.push(nombreHojaOriginal);
        var ws_data = [];
        let nombresColumnas:string[] = [];
        let indiceColumnas=this.columnasExcel.findIndex(item=> item.clave==seccion.clave);
        this.columnasExcel[indiceColumnas].columnas.forEach(columna => {
          // console.log("columna",columna);
          nombresColumnas.push(this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.'+columna))
          contradorColumnas++;
        });
        let seccionesDemo:any[]=[];
        this.jsonCuestionario.sections.forEach(section => {
          if (section.typeSection==6) {
            this.maxQuestions4All=section.maxQuestions;
          }
          if (seccion.clave==section.typeSection) {
            seccionesDemo.push(section.questions)
          }
        });
        console.log("entró la seccion:", seccion.clave);

        let numeroRespuestas:number=0;
        //CICLO PARA ENCONTRAR EL NUMERO MAXIMO DE RESPUESTAS PARA CREAR LAS COLUMNAS DE OPCION_1,...,OPCION_N
        seccionesDemo.forEach(preguntas => {
          if (preguntas.length==0) {
            if(seccion.clave == 2){ //agrega por default 5 respuestas a seccion reactivos
              numeroRespuestas = 5;
            }
          }
          else{
            preguntas.forEach(pregunta => {
              if (numeroRespuestas < pregunta.answers.length) {
                numeroRespuestas=pregunta.answers.length
              }
            });
          }
        });
        console.log('numero de respuestas totales de la seccion:',numeroRespuestas);

        //CICLO QUE COLOCA LOS NOMBRES DE COLUMNAS DE PREGUNTA Y RESPUESTAS DE LA 1 A LA N
        this.idiomas.forEach(idioma => {
          // this.catalogoIdiomasSurvey.forEach(idioma => {   //DESCOMENTAR PARA DESCARGAR TODO EL CATALOGO
          if (idioma.tipoIdioma != "3") {
            if (seccion.clave==6) {
              nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.practice'));  //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
              contradorColumnas++;
              nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.description')); //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
              contradorColumnas++;
              nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.statement_1')); //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
              contradorColumnas++;
              nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.statement_2')); //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
              contradorColumnas++;

            }else{
              nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.question'));  //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
              contradorColumnas++;
              for (let i = 1; i <= numeroRespuestas; i++) {
                nombresColumnas.push(idioma.nombreIdioma+'-'+this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.answer')+'_'+i);  //CAMBIAR nombreIdioma por abbr PARA TODO EL CATALOGO
                contradorColumnas++;
              }
            }
          }
        });
        console.log("Numero de columnas totales:",contradorColumnas);

        ws_data.push(nombresColumnas);

        let totalFilas: number = 0;
        // seccionesDemo.forEach(grupo => {
        for(let grupo of seccionesDemo){
          if (seccion.clave !=6) {
            //CICLO QUE RECORRE TODAS LAS PREGUNTAS DEL GRUPO DE PREGUNTAS DE LA SECCIÓN
            for(let pregunta of grupo){
              totalFilas++;
              let datosPregunta:any[]=[];
              let variablePreguntaExisten=true;
              let indicePreguntaCat = this.preguntasCatalogoMaestro.findIndex(item => item.idUnique==pregunta.idUnique);
              /// HACER EL GETONE DEL CATALOGO MAESTRO
              // const resultado = await this.getDatosPreguntaCatalogo(pregunta.idUnique).then(data => {
              //   console.log('Promise resolved:',data);
              // });;
              // const {question: datosPreguntaCatalogo} = await this.surveyProductService.getPreguntaCatMaster(pregunta.idUnique).toPromise();
              // console.log("datosPreguntaCatalogo:",datosPreguntaCatalogo);

              //Inserta la columna A (Id)
              if (seccion.clave !=6) {
                datosPregunta.push(pregunta.idUnique);
              }
              //Inserta la columna B (Tipo de pregunta)
              switch (pregunta.answerType) {
                case 2:
                if (indicePreguntaCat!=-1) {
                  if(this.preguntasCatalogoMaestro[indicePreguntaCat].jsonCustom.includes('"isTextArea":false')) {
                    datosPregunta.push("2_2");
                  }else{
                    datosPregunta.push("2_1");
                  }
                }else{
                  if (pregunta.jsonCustom.includes('"isTextArea":false')) {
                    datosPregunta.push("2_2");
                  }else{
                    datosPregunta.push("2_1");
                  }
                }
                break;
                default: datosPregunta.push(pregunta.answerType);
              }
              //Inserta la columna C (Tags)
              if (indicePreguntaCat!=-1) {
                datosPregunta.push(this.preguntasCatalogoMaestro[indicePreguntaCat].tags.toString());
              }else{
                datosPregunta.push("");
                variablePreguntaExisten=false;
                totalFilas--;
              }
              //Inserta la columna D (Nueva pregunta)
              switch (pregunta.typeAdd) {
                case 2: datosPregunta.push(2); break;
                default: datosPregunta.push(0);
              }
              //Inserta la columna E (Eliminable)
              switch (pregunta.delete) {
                case true: datosPregunta.push(1); break;
                default: datosPregunta.push(0); break;
              }
              //Inserta la columna F (Editable)
              switch (pregunta.edit) {
                case true: datosPregunta.push(1); break;
                default: datosPregunta.push(0); break;
              }
              //Inserta la columna G (Respuesta obligatoria)
              datosPregunta.push(pregunta.required);
              //Inserta la columna H (Mostrar pregunta)
              datosPregunta.push(1);
              //Dependiendo la sección, agrega columnas adicionales a partir de la I
              switch (seccion.clave) {
                case 2: //SECCION REACTIVOS: Inserta las columnas I, J, K (Dimension, competencia y subcompetencia)
                  datosPregunta.push(pregunta.dimensionId);
                  datosPregunta.push(pregunta.competenceId);
                  datosPregunta.push(pregunta.subcompetenceId);
                break;
                case 4: //SECCION DEMOGRAFICOS: Inserta la columna I (Tipo de demográfico) y J (respuesta tipo 'otro')
                  let demograficoCoincidente = this.catalogoDemograficos.find(item => item.demographicId == pregunta.demographicId);
                  if(demograficoCoincidente != undefined){
                    let idiomaDemografico = demograficoCoincidente.languages.find(item => item.lang == this.idiomaNative);
                    datosPregunta.push(`${pregunta.demographicId}-${idiomaDemografico.key}`);
                  }else{
                    datosPregunta.push("0-")
                  }
                  //respuesta tipo otro
                  const indiceRespuestaOtro = pregunta.answers.findIndex(item => item.answerType == 2);
                  indiceRespuestaOtro == -1 ? datosPregunta.push("") : datosPregunta.push(indiceRespuestaOtro + 1);
                break;
              }
              //Inserta la columnas de textos de preguntas y respuestas si aplica el caso, en los idiomas seleccionados en el producto
              this.idiomas.forEach(idioma => {
                // this.catalogoIdiomasSurvey.forEach(idioma => {   //DESCOMENTAR PARA DESCARGAR TODO EL CATALOGO
                if (idioma.tipoIdioma != "3") {
                  let indiceIdioma = pregunta.questionLanguage.findIndex(item=>item.lang== idioma.nombreIdioma); // CAMBIAR nombreIdioma por abbr para todo el catalogo
                  console.log("preguntaActual:",pregunta, "idioma:",idioma.nombreIdioma,"indice:",indiceIdioma); // CAMBIAR nombreIdioma por abbr para todo el catalogo
                  //Inserta el texto de la pregunta
                  if(indiceIdioma != -1){
                    datosPregunta.push(pregunta.questionLanguage[indiceIdioma].question);
                  }
                  // else{   //DESCOMENTAR PARA DESCARGAR TODO EL CATALOGO
                  //   datosPregunta.push("PREGUNTA CORRUPTA: CORREGIR O ELIMINAR");
                  // }
                  //Inserta los textos de las respuestas, si no hay respuesta agrega una celda vacía
                  for (let i = 0; i < numeroRespuestas; i++) {
                    if (pregunta.answers[i] != undefined) {
                      let indiceIdiomaResp = pregunta.answers[i].answerLanguage.findIndex(item=>item.lang == idioma.nombreIdioma); // CAMBIAR nombreIdioma por abbr para todo el catalogo
                      if(indiceIdiomaResp != -1){
                        datosPregunta.push(pregunta.answers[i].answerLanguage[indiceIdiomaResp].tag);
                      }
                      // else{   //DESCOMENTAR PARA DESCARGAR TODO EL CATALOGO
                      //   datosPregunta.push("RESPUESTA CORRUPTA: CORREGIR O ELIMINAR");
                      // }
                    }else{
                      datosPregunta.push("");
                    }
                  }
                }
              });
              //agrega los datos de la fila al arreglo de la hoja
              if (variablePreguntaExisten){
                console.log('entro este visne tru ');
                ws_data.push(datosPregunta);
              }
            }
          }else{
            for (let i= 0; i < this.maxQuestions4All; i++) {
              let datosPregunta:any[]=[];

              datosPregunta.push(5);
              this.idiomas.forEach(idioma => {
                if (idioma.tipoIdioma != "3") {
                  datosPregunta.push("");//practicas
                  datosPregunta.push("");//descripcion
                  let indiceStatment1= this.pregStatement1.questionLanguage.findIndex(item=>item.lang==idioma.nombreIdioma)
                  let indiceStatment2= this.pregStatement2.questionLanguage.findIndex(item=>item.lang==idioma.nombreIdioma)
                  datosPregunta.push(this.pregStatement1.questionLanguage[indiceStatment1].question);//statement1
                  datosPregunta.push(this.pregStatement2.questionLanguage[indiceStatment2].question);//statement2

                }
              });
              ws_data.push(datosPregunta);


            }
          }

        }
        // });

        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        // oculta la primera columna (IdUnique)

        if (seccion.clave != 6) {
          ws['!cols'] = [];
          ws['!cols'][0] = { hidden: true };
        }else if (seccion.clave==6) {
          ws['!cols'] = [];
        }


        // ws['!protect'] = {};
        // ws['!protect'].selectUnlockedCells = false;
        // ws['A1'] = {};
        // ws['A1'].selectUnlockedCellsx = false;
        // ws['A1']['!protect'] = {};
        // ws['A1']['!protect'].selectUnlockedCells = false;
        // console.log(ws['A1']);

        // Coloca comentarios a las celdas que no deben modificarse, como si les fueran a hacer caso :'v
        let columnasComentarios = ['A','B','C'];
        let texto="TEMPLATE.PANT_TEMPLATE.NO_MODIF";
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        for (let i = 2; i <= (totalFilas+1); i++) {
          columnasComentarios.forEach(letra => {
            if(!ws[letra + i].c){
              ws[letra + i].c = [];
              ws[letra + i].c.hidden = true;
              ws[letra + i].c.push({a:"CGO", t: texto});
              ws[letra + i].s= {									// set the style for target cell
                font: {
                  bold: true,
                  color: { rgb: "D9D9DC" }
                },
                // fill:{
                //   fgColor: { rgb: "e40601"}
                // }
              };
            }
          });
        }

        //COLOCA COMENTARIO CUANDO ES LA HOJA DE DEMOGRAFICOS
        if(seccion.clave == 4){
          let texto = this.translateSrv.instant('TEMPLATE.PANT_TEMPLATE.OPCIONDEMOGRAFICOS');
          for (let i = 1; i <= (totalFilas+1); i++) {
            if(!ws['I' + i].c){
              ws['I' + i].c = [];
              ws['I' + i].c.hidden = true;
              ws['I' + i].c.push({a:"CGO", t: texto});
              ws['I' + i].s= {									// set the style for target cell
                // font: {
                //   bold: true,
                //   color: { rgb: "D9D9DC" }
                // },
                // fill:{
                //   fgColor: { rgb: "e40601"}
                // }
              };
            }
          }
        }

        console.log('catalogosHoja',catalogosHoja);
        console.log('catalogosHoja',contradorColumnas);
        for (let i = 0; i < contradorColumnas; i++) {
          ws[catalogosHoja.LETRAS[i]+'1'].s={
            font: {
              bold: true,
              color: { rgb: "FFFFFF" }
            },
            fill:{
              fgColor: { rgb: "e40601"}
            }
          }
          if (seccion.clave != 6) {

            ws['!cols'][i] = { width: 25 };
          }else if(seccion.clave==6){

            ws['!cols'][i] = { width: 25 };
          }

        }
        console.log(ws);

        wb.Sheets[nombreHoja] = ws;
        // wb.Sheets[nombreHojaOriginal] = ws;
      }

    }else{
      console.log('ENCONTRO LA SECCION FORALL');

    }
  }
  // });
  //crea arreglo sheets para agregarle hidden despues
  wb.Workbook = { Sheets: [] };
  //oculta hojas clones
  wb.Workbook.Sheets = wb.SheetNames.map((x) => {
    let oculto:any = 0;
    if(x.includes("original")){
      oculto = 1;
    }
    return {Hidden: oculto};
  })
  console.log("wb:",wb);

  // wb.Workbook.Sheets[0].Hidden = 1;


  var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

  var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf);  //create uint8array as viewer
  for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

  saveAs(new Blob([buf],{type:"application/octet-stream"}), 'Plantilla Cat'+' - '+this.nombreEmpresa+'-'+this.idiomaNative+'.xlsx');
  Swal.close();

}

creaHojaCatDemograficos(){
  var ws_datacat = [];
  let nombresColumnascat = [
    this.translateSrv.instant('TEMPLATE.COLUMNAS_SECCION.TipoDemografico')
  ];
  ws_datacat.push(nombresColumnascat);

  this.catalogoDemograficos.forEach(demografico => {
    let langAct = this.translateSrv.currentLang;
    let idiomaDemog = demografico.languages.find(item => item.lang == langAct);
    if(idiomaDemog.key != ""){
      ws_datacat.push([
        `${demografico.demographicId}-${idiomaDemog.key}`
      ]);
    }
  });
  var wscat = XLSX.utils.aoa_to_sheet(ws_datacat);
  /// ASIGNA COLORES A NOMBRES COLUMNAS
  let celdasCatalogo=['A'];
  wscat['!cols'] = [];
  celdasCatalogo.forEach((letra,i) => {
    wscat[letra+'1'].s={
      font: {
        bold: true,
        color: { rgb: "FFFFFF" }
      },
      fill:{
        fgColor: { rgb: "e40601"}
      }
    }
    wscat['!cols'][i] = { width: 35 };
  });
  return wscat;
}
creaHojaDetalles(){
  var ws_datacat = [];
  let claveIdiomas=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.ClaveIdiomas'); ////nombres Traduccion Columnas Hoja Catalogo
  let nombreIdiomas=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.NombreIdiomas');////nombres Traduccion Columnas Hoja Catalogo
  let idPregunta=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.IDTipoPregunta');////nombres Traduccion Columnas Hoja Catalogo
  let tiposPregunta=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.TiposPreguntas');////nombres Traduccion Columnas Hoja Catalogo
  let claveElemento=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.ClaveTipoElemento');////nombres Traduccion Columnas Hoja Catalogo
  let tipoElemento=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.TiposElementos');////nombres Traduccion Columnas Hoja Catalogo
  let nombresColumnascat:string[] = [claveIdiomas,nombreIdiomas,idPregunta,tiposPregunta,	claveElemento,	tipoElemento];
  ws_datacat.push(nombresColumnascat);

  let catalogoIdiomasFiltro:any[]=[];

  catalogosHoja.idiomas.forEach(idiomasFiltro => {
    let indiceIdiomas= this.idiomas.findIndex(item=> item.nombreIdioma==idiomasFiltro.nombre);
    if (indiceIdiomas !=-1) {
      catalogoIdiomasFiltro.push(idiomasFiltro);

    }
  });

  catalogosHoja.tiposElementos.forEach((tipoElemento,i) => {

    let datosCatalogo:any[]=[];
    let infoCatalogo:any={
      tiposElementos: tipoElemento,
      idioma: catalogoIdiomasFiltro[i]== undefined? "" : catalogoIdiomasFiltro[i],
      tiposPregunta: catalogosHoja.tiposPregunta[i]== undefined? "" : catalogosHoja.tiposPregunta[i],
    }
    let texto:string;
    if (catalogoIdiomasFiltro[i]== undefined) {

      texto= "";
    }else{
      texto= this.translateSrv.instant('TEMPLATE.CATALOGO_IDIOMAS.'+infoCatalogo.idioma.clave)

    }
    let typepre:string;
    if (catalogosHoja.tiposPregunta[i]== undefined) {
      typepre="";
    }else{

      typepre=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.CONTEM_TIP_PREG.'+infoCatalogo.tiposPregunta.clave);
    }
    let typeseg=this.translateSrv.instant('TEMPLATE.COLUMNAS_H_CATA.CONTEM_TIP_SEGM.'+infoCatalogo.tiposElementos.clave);
    datosCatalogo.push(infoCatalogo.idioma.clave,texto,infoCatalogo.tiposPregunta.clave,typepre,infoCatalogo.tiposElementos.clave,typeseg)
    ws_datacat.push(datosCatalogo);

  });
  var wscat = XLSX.utils.aoa_to_sheet(ws_datacat);
  let celdasCatalogo=['A','B','C','D','E','F'];
  console.log('wscat',wscat);
  wscat['!cols'] = [];
  celdasCatalogo.forEach((letra,i) => {
    wscat[letra+'1'].s={
      font: {
        bold: true,
        color: { rgb: "FFFFFF" }
      },
      fill:{
        fgColor: { rgb: "e40601"}
      }
    }
    wscat['!cols'][i] = { width: 25 };
  });
  return wscat;
}


cargaExcelTemplate(evt: any){
  // let nombreArchivo:string =evt.target.files[0].name.trim();
  // let nombreArchivoDescargado='Plantilla Cat'+' - '+this.nombreEmpresa+'-'+this.idiomaNative+'.xlsx'.trim();
  // console.log(nombreArchivo);
  // console.log(nombreArchivo.length);
  // console.log(nombreArchivoDescargado.length);
  // console.log(nombreArchivoDescargado);

  console.log(" jsoncuestionario",this.jsonCuestionario);
  this.varibleModal=1;
  this.cargandoTemplatePreguntas=true;
  console.log("entro este vines de cargar excel");
  setTimeout(()=>{                           //<<<---using ()=> syntax
    this.cargandoTemplatePreguntas=false;
  }, 3000);

  console.log("variable booleana",this.cargandoTemplatePreguntas);


  const target: DataTransfer = <DataTransfer>(evt.target);
  if (target.files.length !== 1) throw new Error('Cannot use multiple files');
  const reader: FileReader = new FileReader();
  reader.onload = (e: any) => {
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
    console.log("hojas:",wb.SheetNames);
    let BrkExpMain = {};
    try {
      this.tiposSeccionesExcel.forEach(tipoSeccion => {
        let indiceHoja = wb.SheetNames.findIndex(item => item.includes(tipoSeccion.clave + "-"));  //busca el nombre de la hoja por la clave y guión: "1-", "2-", etc
        // let indiceDatosOriginales = wb.SheetNames.findIndex(item => item.includes(tipoSeccion.clave + "_"));  //busca el nombre de la hoja por la clave y guión: "1_", "2_", etc
        const wsname: string = wb.SheetNames[indiceHoja];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];   //hoja con datos visibles
        // const wso: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[indiceDatosOriginales]];   //hoja con datos ocultos
        const datosHoja = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
        // const datosHojaOriginales = <AOA>(XLSX.utils.sheet_to_json(wso, {header: 1}));
        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<------------------------------------------------------------------------>>>>>>>>>>>>>>>>>>>>>>>>");
        console.log("TIPO SECCION:",tipoSeccion.nombre, "datosHoja:",datosHoja);
        //recorre el arreglo de datos de la hoja
        let forallCargadas = 0;
        let cargaCorrecta = true;
        let BreakException = {};
        try {
          datosHoja.forEach((fila,i) => {
            if (tipoSeccion.clave==6) {  ////////+++++++++++++SECCCION 4ALL++++++++++///////
              // console.log("entro el primer if forall");

              let indiceTiposeccion=this.jsonCuestionario.sections.findIndex(item=>item.typeSection==tipoSeccion.clave);
              if (i>0) {
                if(this.maxQuestions4All > forallCargadas){
                  if(this.validaFilaCorrecta(fila,tipoSeccion.clave)){
                    forallCargadas++;
                    // this.totalPreguntaNueva++;
                    // this.totalPreguntas++;
                    // console.log("enttro el if mayor a 0 foral",this.totalPreguntaNueva,'indice',i);

                    let indiceForall= this.jsonCuestionario.sections.findIndex(item=>item.typeSection==6);
                    let idiomasNuevaPreguntaEmpresaStatement1: any[] = [];
                    let idiomasNuevaPreguntaEmpresaStatement2: any[] = [];
                    let objetoStatement1: any[] = [];
                    this.pregStatement1.answers.forEach(element => {
                      let objAnswer: any = {
                        answerLanguage: element.answerLanguage,
                        delete: true,
                        edit: true,
                        idUnique: element.idUnique,
                        logics: [],
                        value: element.value,
                        versionId: element.versionId,
                        vivo: 1,
                      };
                      objetoStatement1.push(objAnswer);
                    });

                    let nativoCompleto=false;
                    this.idiomas.forEach((idioma,i) => {
                      if(idioma.tipoIdioma == 0 || idioma.tipoIdioma == 1){
                        let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idioma.nombreIdioma);
                        let textoPreguntaNuevo = "";
                        let objetoIdiomaStt: any = {
                          idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
                          lang: idioma.nombreIdioma,
                          question: '',
                          description4all: '',
                          practice4all: '',
                          vivo: 1
                        };
                        let objSt1 = JSON.parse(JSON.stringify(objetoIdiomaStt));
                        let objSt2 = JSON.parse(JSON.stringify(objetoIdiomaStt));

                        // textoPreguntaNuevo = event.target.value;
                        objSt1.description4all = fila[(2+(4*i))];
                        objSt2.description4all = fila[(2+(4*i))];
                        objSt1.practice4all = fila[(1+(4*i))];
                        objSt2.practice4all = fila[(1+(4*i))];
                        objSt1.question = fila[(3+(4*i))].replace('$replace1',fila[(1+(4*i))]);
                        objSt2.question = fila[(4+(4*i))].replace('$replace1',fila[(1+(4*i))]).replace('$replace2',this.nombreEmpresa);
                        if (idioma.tipoIdioma == 1) {
                          if (objSt1.practice4all.trim()!="" && objSt1.description4all.trim()!="") {
                            nativoCompleto=true
                            // this.totalPreguntaNueva++;
                            // this.totalPreguntas++;
                          }
                        }

                        idiomasNuevaPreguntaEmpresaStatement1.push(objSt1);
                        idiomasNuevaPreguntaEmpresaStatement2.push(objSt2);


                      }
                    });
                    if (nativoCompleto) {
                      this.totalPreguntaNueva++;
                      this.totalPreguntas++;

                      // console.log("idiomasNuevaPreguntaEmpresaStatement1",idiomasNuevaPreguntaEmpresaStatement1);
                      // console.log("idiomasNuevaPreguntaEmpresaStatement2",idiomasNuevaPreguntaEmpresaStatement2);
                      let datosstatement1: any = {
                        answerType: 5,
                        answers: objetoStatement1,
                        color: 1,
                        columns: this.jsonCuestionario.columns,
                        delete: true,
                        edit: true,
                        idUnique: this.buscaUltimaIdUnique99999(),
                        order: 1,
                        preload: false,
                        questionLanguage: idiomasNuevaPreguntaEmpresaStatement1,
                        required: 1,
                        typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
                        versionId: 1,
                        vivo: 1,
                        editarPregunta: false
                      };

                      this.jsonCuestionario.sections[indiceTiposeccion].questions.push(datosstatement1);
                      let datosstatement2: any = {
                        answerType: 5,
                        answers: this.catalogoRespReactivos,
                        color: 1,
                        columns: this.jsonCuestionario.columns,
                        delete: true,
                        edit: true,
                        idUnique: this.buscaUltimaIdUnique99999(),
                        order: 1,
                        preload: false,
                        questionLanguage: idiomasNuevaPreguntaEmpresaStatement2,
                        required: 1,
                        typeAdd: 0, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
                        versionId: 1,
                        vivo: 1,
                        editarPregunta: false
                      };

                      datosstatement1.answers[0].logics.push({
                        idUniqueQuestion: datosstatement1.idUnique,
                        idUniqueQuestionDaughter: datosstatement2.idUnique,
                      });

                      this.jsonCuestionario.sections[indiceTiposeccion].questions.push(datosstatement2);
                      // console.log("datosstatement1:::",datosstatement1);
                      // console.log("datosstatement2:::",datosstatement2);
                    }
                  }
                }
                else{
                  if(this.validaFilaCorrecta(fila,tipoSeccion.clave)){
                    this.forAllExcedidas = true;
                  }
                }
              }

            }else if(tipoSeccion.clave!=6){
                if(i > 0){    //se salta la primera fila, de los nombres de columnas
                  if(this.validaFilaCorrecta(fila,tipoSeccion.clave)){
                    this.totalPreguntas++;
                    let numeroRespuestas:number=0;
                    let datosPregunta:any;
                    let seccionesDemo:any[]=[];

                    //CICLO QUE FILTRA LAS SECCIONES QUE CORRESPONDEN AL TIPO ACTUAL DEL FOREACH
                    this.jsonCuestionario.sections.forEach(section => {
                      if (section.typeSection==6) {
                        this.maxQuestions4All=section.maxQuestions;
                      }
                      if (tipoSeccion.clave==section.typeSection) {
                        seccionesDemo.push(section.questions)
                      }
                    });

                    //CICLO QUE OBTIENE EL NUMERO MAXIMO DE RESPUESTAS TRAS REVISAR LAS PREGUNTAS DE LAS SECCIONES
                    seccionesDemo.forEach(preguntas => {
                      preguntas.forEach(pregunta => {
                        if (numeroRespuestas < pregunta.answers.length) {
                          numeroRespuestas=pregunta.answers.length
                        }
                      });
                    });

                    console.log("numero de respuestas maximas de la seccion antes: ",numeroRespuestas);

                    //INDICE DE COLUMNA DONDE COMIENZA EL TEXTO DE LA PREGUNTA (PUEDE CAMBIAR DE ACUERDO A LA SECCION)
                    let indidiceInicialPreguntas = 8;
                    switch (tipoSeccion.clave) {
                      case 2: indidiceInicialPreguntas = 11; break;
                      case 4: indidiceInicialPreguntas = 10; break;
                    }
                    let idiomaInicial="";
                    let datosColumnas = datosHoja[0]; //primer arreglo de la hoja son los nombres de las columnas
                    let numeroRespuestasRecalculado = 0;
                    // console.log("datosColumnas",datosColumnas);

                    //CICLO QUE RECORRE DESDE EL INDICE DE COLUMNA DONDE COMIENZA LA PREGUNTA HASTA QUE EL CICLO SE INTERRUMPA
                    for (let i = indidiceInicialPreguntas; ; i++) {
                      // console.log("i",i,'datosColumnas',datosColumnas.length);
                      if (i==indidiceInicialPreguntas) {  //SI EL INDICE ES EL INICIAL SE OBTIENE EL IDIOMA DEL NOMBRE DE COLUMNA
                        idiomaInicial=datosColumnas[i].split("-")[0];
                      }else{
                        if(idiomaInicial!=datosColumnas[i].split("-")[0]) { //SI EL IDIOMA QUE ESTA EN EL NOMBRE DE COLUMNA ES DIFERENTE AL ACTUAL, SE INTERRUMPE EL CICLO
                          break;
                        }else{
                          numeroRespuestasRecalculado++;  //EL NUMERO DE RESPUESTAS SE INCREMENTA
                          if(datosColumnas[i+1]==undefined) { //SI EN LA SIGUIENTE CELDA A LA ACTUAL YA NO HAY VALORES, SE INTERRUMPE EL CICLO
                            break;
                          }
                        }
                      }
                      if(datosColumnas[i+1]==undefined) { //SI EN LA SIGUIENTE CELDA A LA ACTUAL YA NO HAY VALORES, SE INTERRUMPE EL CICLO
                        break;
                      }
                    }

                    console.log("numero de respuestas maximas de la seccion despues: ",numeroRespuestasRecalculado);
                    numeroRespuestas = numeroRespuestas < numeroRespuestasRecalculado ? numeroRespuestasRecalculado : numeroRespuestas;

                    let indiceTiposeccion=this.jsonCuestionario.sections.findIndex(item=>item.typeSection==tipoSeccion.clave);
                    if (fila[3]==2) { /////pregunta nueva
                      console.log("-------- INICIO ANALISIS PREGUNTA NUEVA------------->");

                      this.totalPreguntaNueva++;
                      let tipoPreguntaNueva: number;
                      let tipoAbiertaNueva: string;
                      let idDemografico: number = 0;
                      let splitDemografico: any;

                      switch (fila[1]) {  //SWITCH DE CELDA TIPO PREGUNTA
                        case '2_1': //ABIERTA TIPO TEXTO
                          tipoPreguntaNueva = 2;
                          tipoAbiertaNueva = JSON.stringify(catalogos.jsonCustomAbiertas[0].json);
                        break;
                        case '2_2': //ABIERTA TIPO NUMERICO
                          tipoPreguntaNueva = 2;
                          tipoAbiertaNueva = JSON.stringify(catalogos.jsonCustomAbiertas[1].json);
                        break;
                        case 4: case 6: //MULTIRESPUESTA (UNA OPCION), MULTIRESPUESTA (MULTIPLE OPCION)
                          tipoPreguntaNueva = fila[1];
                          if(tipoSeccion.clave == 4){ //SECCION DEMOGRAFICOS
                            splitDemografico = fila[8].split("-"); //SPLIT DE CELDA TIPO DEMOGRAFICO
                            idDemografico = splitDemografico[0];
                          }
                        break;
                        default:  //RESTO DE PREGUNTAS
                          tipoPreguntaNueva = fila[1];
                        break;
                      }

                      /// DATO DE CELDA ELIMINABLE
                      let delet: boolean = fila[4] == 1 ? true : false;

                      //DATO DE CELDA EDITABLE
                      let edit: boolean = fila[5] == 1 ? true : false;

                      /// CREA EL OBJETO DE LA PREGUNTA VACIO CON IDIOMAS, POSTERIORMENTE SE LE ASIGNAN TEXTOS
                      let idiomasNuevaPregunta: any[] = [];
                      this.idiomas.forEach(idiomaNueva => {
                        if(idiomaNueva.tipoIdioma == 0 || idiomaNueva.tipoIdioma == 1){
                          let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idiomaNueva.nombreIdioma);
                          let textoPreguntaNuevo = "";

                          idiomasNuevaPregunta.push({
                            idLanguage: this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage,
                            lang: idiomaNueva.nombreIdioma,
                            question: textoPreguntaNuevo,
                            vivo: 1
                          });
                        }
                      });

                      // CREA EL OBJETO DE LAS RESPUESTAS VACIAS CON IDIOMAS, POSTERIORMENTE SE LE ASIGNAN TEXTOS
                      let idiomasNuevaAnswers: any[] = [];
                      for (let i = 0; i < numeroRespuestas; i++) {
                        let idiomasAnswer: any[] = [];
                        this.idiomas.forEach(idiomaOpcion => {
                          if(idiomaOpcion.tipoIdioma == 0 || idiomaOpcion.tipoIdioma == 1){
                            let indiceIDlangSurv = this.catalogoIdiomasSurvey.findIndex(item => item.abbr == idiomaOpcion.nombreIdioma);
                            let textoPreguntaNuevo = "";
                            idiomasAnswer.push({
                              idLanguage: parseInt(this.catalogoIdiomasSurvey[indiceIDlangSurv].idLanguage),
                              lang: idiomaOpcion.nombreIdioma,
                              tag: textoPreguntaNuevo,
                              vivo: 1
                            });
                          }
                        });

                        let objetoRespuesta: any = {
                          answerLanguage: idiomasAnswer,
                          delete: false,
                          edit: false,
                          idUnique: (i+1),
                          logics: [],
                          typeAdd: 0,
                          value: (i+1).toString(),
                          versionId: 1,
                          vivo: 1,
                        };

                        //SI LA SECCIÓN ES DEMOGRAFICOS, SE AGREGA EL TIPO DE RESPUESTA (NORMAL U "OTRO")
                        if(tipoSeccion.clave == 4){
                          // console.log("posible respuesta otro");
                          // console.log("condicion 1:",fila[9].toString().length > 0);
                          // console.log("condicion 2:",fila[9] <= numeroRespuestas);
                          // console.log("condicion 3:",typeof fila[9] == 'number');
                          // console.log("condicion 4:",tipoPreguntaNueva == 4);
                          // console.log("condicion 5:",fila[9] == (i+1));
                          objetoRespuesta.answerType = fila[9].toString().length > 0 && fila[9] <= numeroRespuestas && typeof fila[9] == 'number' && tipoPreguntaNueva == 4 && fila[9] == (i+1) ? 2 : 1;
                        }
                        idiomasNuevaAnswers.push(objetoRespuesta);
                      }

                      let datosNuevaPregunta: any = {
                        answerType: tipoPreguntaNueva,
                        color: 1,
                        columns: this.jsonCuestionario.columns,
                        delete: delet,
                        demographicId: idDemografico,
                        edit: edit,
                        idUnique: this.buscaUltimaIdUnique99999(),
                        order: 1,
                        preload: false,
                        questionLanguage: idiomasNuevaPregunta,
                        required: fila[6],
                        typeAdd: 2, //enCM es ahora "typeAdd", 0 es pregunta en tempalte, 1 es pregunta de catalogo no en template y 2 es pregunta nueva no en template ni catalogo
                        versionId: 1,
                        vivo: fila[7],
                        editarPregunta: false
                      };

                      //SWITCH PARA AGREGAR LOS OBJETOS PERSONALIZADOS DE CADA TIPO DE PREGUNTA, SEGÚN APLIQUE
                      switch (tipoPreguntaNueva) {
                        case 2: //abierta
                          datosNuevaPregunta.answers = [];
                          datosNuevaPregunta.jsonCustom = tipoAbiertaNueva;
                        break;
                        case 3: //reactivo
                          datosNuevaPregunta.answers = idiomasNuevaAnswers;
                          datosNuevaPregunta.dimensionId = fila[8];
                          datosNuevaPregunta.competenceId = fila[9];
                          datosNuevaPregunta.descompetenceId = fila[10];
                        break;
                        case 1: case 4: case 6: //nps opciones / una opcion / multiopcion
                          datosNuevaPregunta.answers = idiomasNuevaAnswers;
                        break;
                      }

                      console.log("datoSNuevaPreg, sin textos:",JSON.parse(JSON.stringify(datosNuevaPregunta)));
                      // console.log("datosFila:",fila);

                      // AQUÍ SE REEMPLAZAN LOS TEXTOS VACIOS POR LOS QUE TRAE EL EXCEL
                      this.idiomas.forEach(idioma => {
                        if(idioma.tipoIdioma != "3") {
                          let indiceIdioma: any;
                          for (let i = 0; i <= numeroRespuestas; i++) {
                            if (i==0){  // EL CASO 0 ES CUANDO SE EVALUA EL TEXTO DE LA PREGUNTA
                              indiceIdioma= datosNuevaPregunta.questionLanguage.findIndex(item=>item.lang== idioma.nombreIdioma);
                              if (datosNuevaPregunta.questionLanguage[indiceIdioma].question!= fila[indidiceInicialPreguntas]) {
                                datosNuevaPregunta.questionLanguage[indiceIdioma].question= fila[indidiceInicialPreguntas];
                              }
                            }else{  //LOS DEMAS CASOS SI ES QUE HAY, SON PARA LAS RESPUESTAS
                              if (tipoPreguntaNueva!=2 && tipoPreguntaNueva!=5) {
                                if(datosNuevaPregunta.answers[i-1]!=undefined){
                                  if(tipoPreguntaNueva != 3){ // SI NO ES REACTIVO SE ASIGNAN TEXTOS SI NO ESTAN VACIOS
                                    if (datosNuevaPregunta.answers[i-1].answerLanguage[indiceIdioma].tag!= fila[indidiceInicialPreguntas]) {
                                      datosNuevaPregunta.answers[i-1].answerLanguage[indiceIdioma].tag= fila[indidiceInicialPreguntas];
                                    }
                                  } else{ // SI ES UN REACTIVO, SE ASIGNA LOS TEXTOS QUE NO SON VACIOS, Y LOS VACIOS SE LLENAN CON LAS RESPUESTAS DEFAULT DE REACTIVOS
                                    // console.log("valorCelda "+indidiceInicialPreguntas+":",fila[indidiceInicialPreguntas]);
                                    if(fila[indidiceInicialPreguntas] == '' || fila[indidiceInicialPreguntas] == undefined){
                                      let langCatReact = this.catalogoRespReactivos[i-1].answerLanguage.find(item => item.lang == idioma.nombreIdioma);
                                      datosNuevaPregunta.answers[i-1].answerLanguage[indiceIdioma].tag = langCatReact.tag;
                                    } else{
                                      datosNuevaPregunta.answers[i-1].answerLanguage[indiceIdioma].tag = fila[indidiceInicialPreguntas];
                                    }
                                  }
                                }
                              }
                            }
                            indidiceInicialPreguntas++;
                          }
                        }
                      });
                      console.log("datoSNuevaPreg:",JSON.parse(JSON.stringify(datosNuevaPregunta)));

                      const todasTag = (respuesta) => respuesta.tag != undefined;
                      const minimoUnaTraduccion = (respuesta) => respuesta.tag != undefined && respuesta.tag.length > 0;
                      let arreglo:any[]=[];
                      if (tipoPreguntaNueva!= 2 && tipoPreguntaNueva!= 5 ) {
                        datosNuevaPregunta.answers.forEach(answer => {
                          // let  indiceNoUndefined= answer.answerLanguage.findIndex(item=> item.tag!=undefined);
                          // if (indiceNoUndefined!=-1) {
                          //   arreglo.push(answer);
                          //
                          // }
                          // if(answer.answerLanguage.every(todasTag)){
                          if(answer.answerLanguage.some(minimoUnaTraduccion)){
                            arreglo.push(answer);
                          }
                        });
                        datosNuevaPregunta.answers=arreglo;
                        console.log("respuestas con texto ",arreglo);
                      }


                      // console.log("jsonCuest:",this.jsonCuestionario.sections);
                      // console.log("indiceTiposeccion:",indiceTiposeccion);
                      if(indiceTiposeccion != -1){
                        this.jsonCuestionario.sections[indiceTiposeccion].questions.push(datosNuevaPregunta);
                      }
                      else{
                        let idiomasNuevaSeccion: any[] = [];
                        this.catalogoIdiomasSurvey.forEach(idioma => {
                          idiomasNuevaSeccion.push({
                            idLanguage: idioma.idLanguage,
                            lang: idioma.abbr,
                            textSection: "textoPreguntaNuevo",
                            vivo: 1
                          });
                        });
                        this.jsonCuestionario.sections.push({
                          addCatQuestions: true,
                          addNewQuestions: true,
                          color: 1,
                          deleteQuestions: true,
                          editQuestions: true,
                          insurvey: false,
                          logicSection: "",
                          maxQuestions: 999999,
                          moveQuestions: true,
                          nameSection: tipoSeccion.nombre,
                          orderSection: 99,
                          questions: [],
                          sectionsLanguages: idiomasNuevaSeccion,
                          typeSection: tipoSeccion.clave,
                          vivo: 1
                        });
                        indiceTiposeccion = this.jsonCuestionario.sections.findIndex(item=>item.typeSection==tipoSeccion.clave);
                        this.jsonCuestionario.sections[indiceTiposeccion].questions.push(datosNuevaPregunta);
                      }

                      console.log("------- FIN PROCESO ANALISIS PREGUNTA NUEVA ----------");

                    }else{  //////*******************************MODIFICAR PREGUNTA*******************************///////////
                    let preguntaModificada=false;
                    //Busca los datos de la pregunta del template que corresponde al ID Unique de turno

                    this.jsonCuestionario.sections.forEach(secciones => {
                      secciones.questions.forEach(question => {
                        if (question.idUnique== fila[0]){
                          datosPregunta=question;
                        }
                      });
                    });
                    if (tipoSeccion.clave!=6) {
                      // console.log("entro pregunta modificada para las demas seccion menos forall");

                      // Busca los datos de la pregunta del catálogo que corresponde a la pregunta actual
                      let indicePreguntaCat= this.preguntasCatalogoMaestro.findIndex(item => item.idUnique==fila[0]);
                      /// HACER EL GETONE DEL CATALOGO MAESTRO
                      // const {question: datosPreguntaCatalogo} = await this.surveyProductService.getPreguntaCatMaster(fila[0]).toPromise();
                      //Modifica la columma B (tipo de pregunta)
                      let nuevoTipoPregunta: number;
                      // console.log("datosPregunta",datosPregunta);
                      console.log("datosPreguntaAlInicio",JSON.parse(JSON.stringify(datosPregunta)));

                      if (datosPregunta.answerType!=fila[1]) {
                        if (fila[1]!='2_1' && fila[1]!='2_2') {
                          // datosPregunta.answerType=fila[1];
                          nuevoTipoPregunta = fila[1];
                        }else{
                          // datosPregunta.answerType=2;
                          nuevoTipoPregunta = 2;
                        }
                      }
                      else nuevoTipoPregunta = fila[1];

                      //Revisa si es diferente a la original, si lo es, se rechaza el archivo
                      if(datosPregunta.answerType != nuevoTipoPregunta){
                        // console.log("tronó:",datosPregunta.answerType ,"!=", nuevoTipoPregunta);
                        cargaCorrecta = false;
                        throw BreakException;
                      }
                      let tags:any[]=[];
                      let tagString = this.preguntasCatalogoMaestro[indicePreguntaCat].tags.toString();
                      //Modifica la columna C (tags)
                      if (tagString!=fila[2]) {
                        // CODIGO CORRECTO, COMENTADO TEMPORALMENTE
                        // tags = fila[2].split(",");
                        // this.preguntasCatalogoMaestro[indicePreguntaCat].tags=tags;
                        // this.actualizaPreguntaCatMaster(this.preguntasCatalogoMaestro[indicePreguntaCat]);
                        // console.log("tronó:",tagString,"!=", fila[2]);
                        cargaCorrecta = false;
                        throw BreakException;
                      }
                      let eliminable:boolean;
                      if(fila[4]==1) {
                        eliminable=true;
                      }else{
                        eliminable=false;
                      }
                      // Modifica la columna E (eliminable)
                      if (datosPregunta.delete!=eliminable) {
                        datosPregunta.delete=eliminable;
                        preguntaModificada=true;
                        // console.log("ENTRO AQUI 1++++++ ");

                      }

                      let edit:boolean;
                      if (fila[5]==1) {
                        edit=true;
                      }else{
                        edit=false;
                      }
                      // Modifica la columna F (editable)
                      if (datosPregunta.edit!=edit) {
                        datosPregunta.edit=edit;
                        preguntaModificada=true;
                        // console.log("ENTRO AQUI 2++++++ ");
                      }
                      // Modifica la columna G (respuesta obligatoria)
                      if (datosPregunta.required!=fila[6]) {
                        datosPregunta.required=fila[6];
                        preguntaModificada=true;
                        // console.log("ENTRO AQUI 3++++++ ");
                      }
                      // Modifica la columna H (mostrar pregunta)
                      if (datosPregunta.vivo!=fila[7]) {
                        datosPregunta.vivo=fila[7];
                        preguntaModificada=true;
                        // console.log("ENTRO AQUI 5++++++ ");
                      }

                      let indidiceInicialPreguntas=8;
                      // Dependiendo la sección, modifica otras columnas
                      switch (tipoSeccion.clave) {
                        case 2:
                          indidiceInicialPreguntas=11;
                          // Modifica la columna I (dimension)
                          if (datosPregunta.dimensionId!=fila[8]) {
                            datosPregunta.dimensionId=fila[8]
                            preguntaModificada=true;
                            // console.log("ENTRO AQUI 6++++++ ");
                          }
                          // Modifica la columna J (competencia)
                          if (datosPregunta.competenceId!=fila[9]) {
                            datosPregunta.competenceId=fila[9]
                            preguntaModificada=true;
                            // console.log("ENTRO AQUI 7++++++ ");
                          }
                          // Modifica la columna K (subcompetencia)
                          if (datosPregunta.subcompetenceId!=fila[10]) {
                            datosPregunta.subcompetenceId=fila[10]
                            preguntaModificada=true;
                            // console.log("ENTRO AQUI 8++++++ ");
                          }
                        break;
                        case 4:
                          indidiceInicialPreguntas = 10;
                          let split= fila[8].split("-");
                          // Modifica la columna I (tipo de demográfico)
                          if(datosPregunta.demographicId!=split[0]) {
                            datosPregunta.demographicId=split[0]
                            preguntaModificada=true;
                            // console.log("ENTRO AQUI 9++++++ ");
                          }
                          ////RESPUESTA TIPO OTRO
                          const respuestaOtro = fila[9];
                          if(respuestaOtro.toString().length > 0){
                            let respuestaOtroActual = datosPregunta.answers[respuestaOtro - 1];
                            if(respuestaOtroActual != undefined){
                              if(respuestaOtroActual.answerType != undefined){
                                if(respuestaOtroActual.answerType != 2){  //si la respuesta indicada en el excel no es la "otro"
                                  let respuestaOtroReal = datosPregunta.answers.find(item => item.answerType == 2);
                                  if(respuestaOtroReal != undefined){
                                    respuestaOtroReal.answerType = 1;
                                    respuestaOtroReal.typeAdd = 2;
                                  }
                                  respuestaOtroActual.answerType = 2;
                                  respuestaOtroActual.typeAdd = 2;
                                  preguntaModificada=true;
                                }
                              } else{
                                respuestaOtroActual.answerType = 2
                                respuestaOtroActual.typeAdd = 2;
                                preguntaModificada=true;
                              }
                            }
                          } else{
                            let respuestaOtroReal = datosPregunta.answers.find(item => item.answerType == 2);
                            if(respuestaOtroReal != undefined){
                              respuestaOtroReal.answerType = 1;
                              respuestaOtroReal.typeAdd = 2;
                              preguntaModificada=true;
                            }
                          }
                        break;
                      }

                      // console.log("///////////////////////////");
                      // console.log("datosFila:",fila);
                      // console.log("tipoclave:",tipoSeccion.clave);
                      // console.log("numeroRespuestas:",numeroRespuestas);


                      let textoPregunta:boolean;
                      this.idiomas.forEach(idioma => {
                        if(idioma.tipoIdioma != "3") {
                          let indiceIdioma: any;

                          for (let i = 0; i <= numeroRespuestas; i++) {
                            // console.log("entro ciclo for:",i);
                            // console.log("indidiceInicialPreguntas:",indidiceInicialPreguntas);
                            if (i==0){  //Compara el texto de la pregunta
                              indiceIdioma = datosPregunta.questionLanguage.findIndex(item=>item.lang== idioma.nombreIdioma);
                              let textQuestionario = datosPregunta.questionLanguage[indiceIdioma].question.trim();
                              // console.log("texto pregunta:",fila[indidiceInicialPreguntas]);

                              if(fila[indidiceInicialPreguntas] != undefined){  //si el texto de la pregunta existe
                                let textexcel = fila[indidiceInicialPreguntas].toString().trim().replaceAll('\r',"");
                                if (textQuestionario.localeCompare(textexcel)!=0) {
                                  // console.log('tamaño1:',JSON.stringify(textQuestionario),':');
                                  // console.log('Tamaño2:',JSON.stringify(textexcel),':');
                                  datosPregunta.questionLanguage[indiceIdioma].question= fila[indidiceInicialPreguntas].toString();
                                  datosPregunta.typeAdd=4;
                                  preguntaModificada=true;
                                  // console.log("ENTRO AQUI 10++++++ ");
                                }
                              } else{   //si no existe, se guarda una celda vacia
                                if (textQuestionario.localeCompare('') != 0) {
                                  datosPregunta.questionLanguage[indiceIdioma].question = '';
                                  datosPregunta.typeAdd=4;
                                  preguntaModificada=true;
                                }
                              }
                            }
                            else{ //Compar los textos de las respuestas
                              if (datosPregunta.answerType!=2 && datosPregunta.answerType!=5) {
                                console.log("indice:",indidiceInicialPreguntas," dato:",fila[indidiceInicialPreguntas]);

                                if(datosPregunta.answers[i-1]!=undefined){
                                  // console.log("answer de pregunta existe");

                                  if(fila[indidiceInicialPreguntas] != undefined){
                                    if(fila[indidiceInicialPreguntas] == '' && nuevoTipoPregunta == 3){   //si la respuesta esta vacia '' y la pregunta es tipo reactivo, se le agrega la respuesta faltante
                                      // console.log("entro este caso");
                                      let langCatReact = this.catalogoRespReactivos[i-1].answerLanguage.find(item => item.lang == idioma.nombreIdioma);
                                      datosPregunta.answers[i-1].answerLanguage[indiceIdioma].tag = langCatReact.tag;
                                      datosPregunta.answers[i-1].typeAdd = 5;
                                      datosPregunta.typeAdd = 5;
                                      preguntaModificada = true;
                                      // console.log("datosResp:",datosPregunta.answers[i-1]);

                                    } else{
                                      if (datosPregunta.answers[i-1].answerLanguage[indiceIdioma].tag.toString().trim() != fila[indidiceInicialPreguntas].toString().trim()) {
                                        datosPregunta.answers[i-1].answerLanguage[indiceIdioma].tag= fila[indidiceInicialPreguntas].toString();
                                        datosPregunta.answers[i-1].typeAdd = 5;
                                        datosPregunta.typeAdd = 5;
                                        preguntaModificada=true;
                                        // console.log("ENTRO AQUI 11++++++ ");
                                      }
                                    }
                                  }
                                  else{
                                    // console.log("entro pos fila undefined");

                                    if(nuevoTipoPregunta != 3){ //si no es tipo reactivo
                                      datosPregunta.answers[i-1].answerLanguage[indiceIdioma].tag = '';
                                      datosPregunta.answers[i-1].typeAdd = 5;
                                      datosPregunta.typeAdd = 5;
                                      preguntaModificada = true;
                                      // console.log("ENTRO AQUI 12++++++ ");
                                    } else{ // si es tipo reactivo se completan la respuestas que esten vacias con las de catalogo
                                      let langCatReact = this.catalogoRespReactivos[i-1].answerLanguage.find(item => item.lang == idioma.nombreIdioma);
                                      datosPregunta.answers[i-1].answerLanguage[indiceIdioma].tag = langCatReact.tag;
                                      datosPregunta.answers[i-1].typeAdd = 5;
                                      datosPregunta.typeAdd = 5;
                                      preguntaModificada = true;
                                    }
                                    // console.log("datosResp:",datosPregunta.answers[i-1]);
                                  }
                                }
                                else{
                                  // console.log("answer de pregunta no existe");
                                  let idiomasAnswer: any[] = [];
                                  if(tipoSeccion.clave == 2){ //si la pregunta es un reactivo
                                    idiomasAnswer = this.catalogoRespReactivos[i-1].answerLanguage;
                                    console.log("respReact:",this.catalogoRespReactivos);
                                  } else{ //SE COMENTÓ ESTE CODIGO PARA QUE NO AGREGUE RESPUESTAS VACIAS SI HAY CELDAS VACIAS EN RESPUESTAS
                                    if(fila[indidiceInicialPreguntas] != undefined && fila[indidiceInicialPreguntas] != ""){
                                      // console.log("existe texto respuesta:",fila[indidiceInicialPreguntas]);

                                      this.catalogoIdiomasSurvey.forEach(idiomaCat => {
                                        let textoPreguntaNuevo = "";
                                        if(idiomaCat.abbr == idioma.nombreIdioma){
                                          textoPreguntaNuevo = fila[indidiceInicialPreguntas] != "" ? fila[indidiceInicialPreguntas] : "";
                                        }
                                        idiomasAnswer.push({
                                          idLanguage: idiomaCat.idLanguage,
                                          lang: idiomaCat.abbr,
                                          tag: textoPreguntaNuevo,
                                          vivo: 1
                                        });
                                      });
                                      // console.log("idiomasAnswer generado:",idiomasAnswer);

                                    } else{
                                      // console.log("el textoRespuesta de ",indidiceInicialPreguntas," es undefeined:",fila[indidiceInicialPreguntas]);

                                    }
                                  }
                                  if(idiomasAnswer.length > 0){
                                    datosPregunta.answers.push({
                                      answerLanguage: idiomasAnswer,
                                      delete: false,
                                      edit: false,
                                      idUnique: i,
                                      logics: [],
                                      typeAdd: 0,
                                      value: i.toString(),
                                      versionId: 1,
                                      vivo: 1,
                                    });
                                    datosPregunta.typeAdd=5;
                                  }
                                }
                              }
                            }
                            indidiceInicialPreguntas++;
                          }
                        }

                      });
                      console.log("datosPreguntaAlFinal",JSON.parse(JSON.stringify(datosPregunta)));
                      if (preguntaModificada==true) {
                        this.totalPreguntaModificadas++;
                      }

                    }
                  }
                  }
                }
              }
          });
          this.files.push(this.jsonCuestionario);

          console.log("este es el nuevo jsoncuestionario",JSON.parse(JSON.stringify(this.jsonCuestionario)));
          // console.log("este es el nuevo preguntasCatalogoMaestro",this.preguntasCatalogoMaestro);
          // console.log("totalPreguntasNuevas",this.totalPreguntaNueva);
          console.log("totalPreguntasModificadas",this.totalPreguntaModificadas);
          // console.log("totalPreguntas",this.totalPreguntas);
          // console.log("this.files",this.files);
        } catch (e) {
          if (e !== BreakException) throw e;
        };
        if(!cargaCorrecta){

          Swal.fire({
            icon: 'error',
            title: this.translateSrv.instant('TEMPLATE.PANT_TEMPLATE.ERROR_CARGA'),
            confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_OK'),
            showLoaderOnConfirm: true,
            width: '40%',
            allowOutsideClick: () => !Swal.isLoading()
          });
          this.deleteAttachment();
          throw BrkExpMain;
        }
      });
      if(this.forAllExcedidas){
        Swal.fire({
          icon: 'warning',
          title: this.translateSrv.instant('TEMPLATE.PANT_TEMPLATE.FORALL_EXCEDIDAS'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.TAB_PREGUNTAS.MSJ_MODALES.BTN_OK'),
          showLoaderOnConfirm: true,
          width: '40%',
          allowOutsideClick: false
        });
      }
    } catch (e) {
      if (e !== BrkExpMain) throw e;
    };
  };


  reader.readAsBinaryString(target.files[0]);
  evt.target.value = '';
}

validaFilaCorrecta(datos: any, tipoSeccion: any){
  let filaCorrecta = true;
  let tamanioMinimo = [
    {seccion: 1, minimo: 9},
    {seccion: 2, minimo: 12},
    {seccion: 3, minimo: 9},
    {seccion: 4, minimo: 10},
    {seccion: 5, minimo: 9},
    {seccion: 6, minimo: 5},
  ];
  if(tipoSeccion != 6){ //si no es una forall
    if(datos.length > 0){
      let indiceTamanioSecc = tamanioMinimo.findIndex(item => item.seccion == tipoSeccion);
      if(indiceTamanioSecc != -1){
        if(datos.length >= tamanioMinimo[indiceTamanioSecc].minimo){
          if(typeof datos[3] === 'number' && datos[3] != null){ //revisa si la celda D es tipo numerica y no esta vacia
            if(datos[3] == 0){  //si la pregunta no es nueva
              if(typeof datos[0] != 'number' || datos[0] == null) filaCorrecta = false; // revisa si la celda A no es numerica o esta vacia
            }
            if(datos[1] == '') filaCorrecta = false;  //si la celda B esta vacia
            if(typeof datos[4] != 'number' || datos[4] == null) filaCorrecta = false; // revisa si la celda E no es numerica o esta vacia
            if(typeof datos[5] != 'number' || datos[5] == null) filaCorrecta = false; // revisa si la celda F no es numerica o esta vacia
            if(typeof datos[6] != 'number' || datos[6] == null) filaCorrecta = false; // revisa si la celda G no es numerica o esta vacia
            if(typeof datos[7] != 'number' || datos[7] == null) filaCorrecta = false; // revisa si la celda H no es numerica o esta vacia
            switch (tipoSeccion) {
              case 2: // seccion reactivos
                if(datos[8].length == 0) filaCorrecta = false; // revisa si la celda I esta vacia
                if(datos[9].length == 0) filaCorrecta = false; // revisa si la celda J esta vacia
                if(datos[10].length == 0) filaCorrecta = false; // revisa si la celda K esta vacia
              break;
              case 4: // seccion demograficos
                if(datos[8].length == 0) filaCorrecta = false; // revisa si la celda I esta vacia
              break;
            }
          }
          else filaCorrecta = false;
        }
        else filaCorrecta = false;
      }
    }
    else filaCorrecta = false;
  }
  else if(tipoSeccion == 6){  //si es una forall
    if(datos.length > 0){
      let indiceTamanioSecc = tamanioMinimo.findIndex(item => item.seccion == tipoSeccion);
      if(indiceTamanioSecc != -1){
        if(datos.length >= tamanioMinimo[indiceTamanioSecc].minimo){
          if(typeof datos[0] != 'number' || datos[0] == null) filaCorrecta = false; // revisa si la celda A no es numerica o esta vacia
        }
        else filaCorrecta = false;
      }
    }
    else filaCorrecta = false;
  }
  // console.log("datosFila:",datos," correcta:",filaCorrecta);
  return filaCorrecta;
}


actualizaPreguntaCatMaster(datosPregunta:any, indiceSeccion?:number, indicePregunta?:number){
  this.templateService.setPreguntaCatMaster(datosPregunta).subscribe((respuesta:any) => {
    console.log("setPreguntaCatMaster:",respuesta);
    // if(respuesta.success){
    //   let confirMsg: string;
    //   let indicePregCat = this.catalogoDemo.findIndex(item => item.idUnique == respuesta.question.idUnique);
    //   if(indicePregCat != -1){
    //   this.catalogoDemo[indicePregCat] = respuesta.question;
    //   }
    // }
  });
}

deleteAttachment(index?:number, origen?:boolean) {
  this.cargaTemplate=false;
  this.cargandoTemplatePreguntas=false;
  this.guardandoTemplatePreguntas=false;
  this.varibleModal=0;
  this.files=[];
  this.totalPreguntaNueva=0;
  this.totalPreguntaModificadas=0;
  this.totalPreguntas=0;
  // this.getSeccionesCuestionario();
  this.surveyProductService.enviaDatosASurvProd({ recuperaInformacion: true });
  this.recibeDatosSP();
}

guardaPlantillaExcel(){
  console.log("cargaTemplate",this.cargaTemplate);
  this.varibleModal=2;
  this.cargandoTemplatePreguntas=true;
  this.guardandoTemplatePreguntas = true;

  setTimeout(()=>{
    this.actualizaCuestionario();
  }, 3000);

}

actualizaCuestionario(){
  this.jsonCuestionario.sections.forEach(seccion => {
    seccion.questions.forEach(pregunta => {
      console.log("--------------------------------");

      console.log("preguntaActualizar:",pregunta);

      pregunta.answers.forEach(opcion => {
        this.catalogoIdiomasSurvey.forEach(idioma => {
          let textoPreguntaNuevo = "";

          let indiceIdiomaExistente= opcion.answerLanguage.findIndex(item=>item.lang==idioma.abbr);
          if(indiceIdiomaExistente == -1){
            opcion.answerLanguage.push({
              idLanguage: idioma.idLanguage,
              lang: idioma.abbr,
              tag: textoPreguntaNuevo,
              vivo: 1
            });
          }
        });
      });


      this.catalogoIdiomasSurvey.forEach(idioma => {
        let textoPreguntaNuevo = "";

        let indiceIdiomaExistente= pregunta.questionLanguage.findIndex(item=>item.lang==idioma.abbr);
        if(indiceIdiomaExistente == -1){
          pregunta.questionLanguage.push({
            idLanguage: idioma.idLanguage,
            lang: idioma.abbr,
            question: textoPreguntaNuevo,
            vivo: 1,
            description4all: "",
            practice4all: "",
          });
        }
      });




    });
  });

  console.log("jsonCuestionario:",this.jsonCuestionario);
          this.jsonCuestionario.accionText='subColabUpdateTemplatePre';
          this.jsonCuestionario.userAdministrator=this.nameUserAdmin;
          this.jsonCuestionario.section=0
          this.jsonCuestionario.broker=this.instUtc,
  console.log('JsonCuestionarioActualizado',this.jsonCuestionario)
  this.templateService.setSeccionesCuestionario(this.productoCertificar.surveyProductId._id,this.jsonCuestionario).subscribe((respuesta:any) => {
    console.log("actualizaCuestionario:",respuesta);
this.postActualizaTemplate();
this.enviaOrdenWizardNotificiaciones();


  });


}

postActualizaTemplate(){
  let datos={
    surveyProductId:this.productoCertificar.surveyProductId._id,
    totalQuestions: this.totalPreguntas,
    newQuestions:this.totalPreguntaNueva,
    modifiedQuestions:this.totalPreguntaModificadas,
  }
  console.log("datosd",datos);

  this.templateService.postActualizaTemplate(datos).subscribe((respuesta:any) => {
    console.log("se actualizo ok",respuesta);
    Swal.fire({
      title: this.translateSrv.instant('TEMPLATE.PANT_TEMPLATE.SUCC_CAR_PLAN'),
      icon: "success",
      confirmButtonColor: '#e40601'
    });
    this.guardandoTemplatePreguntas=false;
    this.cargandoTemplatePreguntas=false;
    this.varibleModal=0;
    this.files=[];
    this.totalPreguntaNueva=0;
    this.totalPreguntaModificadas=0;
    this.totalPreguntas=0;
    this.sinModificacionTemplate=true;
this.getActualizaTemplate();
  });
}

obtieneInstituto(){
  let institutoAct = this.wizardService.getInstituto();
  console.log(institutoAct);
  switch(institutoAct){
    case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
    case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_CAYC; break;
    case '3': case '22': case 'HK': this.instituto = 'HK'; this.instUtc = 3;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_HK; break;
    case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
    case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5;  this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_TK; break;
    case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
    case '8': case 'IZZI': this.instituto = 'IZZI'; this.instUtc = 1;  break;
    case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
    case '14': case 'GCTI': this.instituto = 'GCTI'; this.instUtc = 14;  break;
    case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
    case '18': case 'AMCO': this.instituto = 'AMCO'; this.instUtc = 18;  break;
    case '19': this.instituto = 'GCTI'; this.instUtc = 19;  break;
    default: this.instituto = 'WLDWDE';
  }
  //se coloca aqui porque dentro de esa funcion se requiere tener el instituto
  this.traduceTextosTS();
}

getStatusModal(){
  let datos={
    productoId: this.productoCertificar.idCertificar,
    template: 1
  };
  console.log(datos);
  this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
    if(data.estatus==1){
      this.modalInformativo('TEMPLATE');
    }
  });
}



updateStatusModal(){
  let datos={
    productoId: this.productoCertificar.idCertificar,
    template: 2
  };
  this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {});
}

modalInformativo(OPCIONMODAL:string){
  let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
  let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
  Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
}

// ModalArchivo(){
//   let botonModalArchivo = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.ARCHIVOCOMFIRM';
//   this.translateSrv.get(botonModalArchivo).subscribe((res: string) => { botonModalArchivo = res; });
//   let rspEnterado = 'MODALES.ACCIONES.aceptar';
//   this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });
//   Swal.fire({
//     title: botonModalArchivo,
//     icon: 'warning',
//     showCancelButton: false,
//
//     confirmButtonText: rspEnterado,
//
//   });
// }

traduceTextosTS(){
  this.idiomaUtc = this.translateSrv.currentLang;
  switch(this.translateSrv.currentLang){
    case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
    case 'zh1': case 'zh2':
    if(this.instituto == 'HK'){
      this.idiomaActual = this.translateSrv.currentLang;
    }
    else{
      this.idiomaActual = 'en';
    }
    break;
    case 'tr':
    if(this.instituto == 'TK'){
      this.idiomaActual = this.translateSrv.currentLang;
    }
    else{
      this.idiomaActual = 'en';
    }
    break;
    default: this.idiomaActual = 'en';
  }
}

mensajeSwal(mensaje:string, tipoMsg:number){
  let tipo: any;
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  switch(tipoMsg){
    case 1: tipo = 'success'; break;
    case 2: tipo = 'warning'; break;
    case 3: tipo = 'error'; break;
  }
  Swal.fire({
    title: mensaje,
    icon: tipo,
    confirmButtonText: rspSi,
    confirmButtonColor: '#e40601'
  });
}

infoError(detalleError:string){
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  Swal.fire({
    title: this.translateSrv.instant('CERTIFICAR.COLABORADORES.CARD_ERRLIST.DESCRIPCION.'+detalleError),
    icon: 'warning',
    confirmButtonText: rspSi,
    confirmButtonColor: '#e40601'
  });
}



completarPaso(){
if (this.pasoCompleto) {
  let textomessage = this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO');
  this._snackBar.open(textomessage, "Ok", {
    duration: 2000,
    horizontalPosition: "center",
    verticalPosition: "top",
    panelClass: ['background-red']
  });

}else{
  console.log('El paso aún no está completado');

  if (this.sinModificacionTemplate==false) {
    Swal.fire({
      title: this.translateSrv.instant('TEMPLATE.PANT_TEMPLATE.COMPL_PAS_SIN_MODI'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,


      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BOTON_CANCEL'),
    }).then((result) => {
      if (result.value) {
        let datos:any={
          accionText:'completePasTemplate',
          productoId:this.productoCertificar.idCertificar,
          template: 3,
          userAdministrator:this.nameUserAdmin,
        }
        this.templateService.guardaStatusTemplate(datos).subscribe( (data: backInter.RespuestaGen) => {
          // if(data.message == '211'){

            //this.aletaRestric('COLABORADORES.'+data.message,null,'success');
            let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
            this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
            this.openSnackBar(textoMensaje,"OK");
            this.pasoCompleto = true;
            this.enviaOrdenWizard();
            Swal.close();
            // };
            this.surveyProductService.enviaDatosASurvProd({ actualizarProducto: true });
          });


        }
      });

    }else{
      this.aletaRestric('TEMPLATE.PANT_TEMPLATE.COMPLE_PASO_CON_MODI',true);

    }

}

}

enviaOrdenWizard(){
  this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
}

desbloquearColaboradores(){
  let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.TITULO_DESBLOQUEAR';
  let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BOTON_CONFIRM';
  let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BOTON_CANCEL';
  let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.SUCCES';
  let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.BLOQUEADO';
  let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.COLABORADORES.CERRAR';
  this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
  this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
  this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
  this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
  this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
  this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
  if(this.pasoCompleto==true){
    Swal.fire({
      title: tituloDesbloquear,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: confirmar,
      cancelButtonText: cancelar
    }).then((result) => {
      if (result.value) {
        let datos={
          accionText:'DescompleteTemplate',
          productoId:this.productoCertificar.idCertificar,
          template: 2,
          userAdministrator:this.nameUserAdmin,
          actualizar:1,
        }
        console.log("Descompletar paso Colaboradores");
        this.colaboradoresService.DesbloquearPasoColaboradores(datos).subscribe( (data: backInter.RespuestaGen) => {
          console.log(data);
          if(data.message == '211'){
            this.pasoCompleto = false;
            this.openSnackBar(succes,"OK");
            this.enviaOrdenWizard();
            this.enviaOrdenWizardNotificiaciones();
            /*Swal.fire({
            icon: 'success',
            title: succes,
            showConfirmButton: true,

            confirmButtonText: cerrar,
          })*/
        };
      });
    }
  });
}
else{
  Swal.fire({
    icon: 'warning',
    title: bloqueado,
    showConfirmButton: true,

    confirmButtonText: cerrar,
  })
}
}

openSnackBar(message: string, action: string) {
  Swal.close();
  this._snackBar.open(message, action, {
    duration: 2000,
  });
}


aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){
  let texto = mensaje;
  let rspSi = 'MODALES.ACCIONES.aceptar';
  let rspNo = 'MODALES.ACCIONES.cancelar';
  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

  if(confirmar){
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        let datos={
          accionText:'completePasTemplate',
          productoId:this.productoCertificar.idCertificar,
          template: 3,
          userAdministrator:this.nameUserAdmin,
          actualizar:1,
        }

        this.templateService.guardaStatusTemplate(datos).subscribe( (data: backInter.RespuestaGen) => {
          // if(data.message == '211'){

          //this.aletaRestric('COLABORADORES.'+data.message,null,'success');
          let textoMensaje ="MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.210";
          this.translateSrv.get(textoMensaje).subscribe((res: string) => { textoMensaje = res; });
          this.openSnackBar(textoMensaje,"OK");
          this.pasoCompleto = true;
          this.enviaOrdenWizard();
          this.enviaOrdenWizardNotificiaciones();
          Swal.close();
          this.surveyProductService.enviaDatosASurvProd({ actualizarProducto: true });
          // };
        });
      }
    });
  }
  else{
    let tipoMsg: any = tipo;
    Swal.fire({
      title: texto,
      icon: tipoMsg,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }
}

enviaOrdenWizardNotificiaciones(){
  // this.wizardService.puenteDatosNotificaciones("100"); //100 = actualiza los status de los steps
  let datos:any={actua:"100",nivelNotif: this.nivelNotificacion}
  this.authService.puenteDatosQuick(datos);
}

ngOnDestroy(): void
{
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
}

}
